<template>

	<v-row class="mt-5 mb-5">

		<v-col offset-lg="4" lg="4" offset-md="3" md="6" offset-sm="2" sm="8">
		
			<form @submit.prevent="changePassword()">

				<v-card class="pa-4" style="background: #101010;" elevation="20">

					<div class="text-center mb-3">
	    			<router-link to="/">
	    				<img src="@/assets/img/logo.png" width="150">
	    			</router-link>
	    		</div>

					<h3 class="text-center mt-3 mb-5">Restaurar contraseña</h3>

					<v-text-field
						type="email"
	          label="Correo electrónico"
	          v-model="user.email"  
	          filled
	          dark
	          required
	          disabled
	        ></v-text-field>

	        <v-text-field
						type="password"
	          label="Nueva contraseña"
	          minlength="8"
	          maxlength="20"
	          v-model="user.password"   
	          filled
	          dark
	          required
	        ></v-text-field>

	        <v-text-field
						type="password"
	          label="Repetir contraseña"
	          minlength="8"
	          maxlength="20"
	          v-model="user.password_confirm" 
	          filled
	          dark
	          required
	        ></v-text-field>

			    <v-btn type="submit" x-large block>
			      Restaurar
			    </v-btn>

			    <p class="mt-5 mb-4 text-center">
			    	<small style="color: gray">&copy; 2023 WOW ENVÍOS</small>
			    </p>

				</v-card>

			</form>
	
	  </v-col>

	</v-row>

</template>


<script>
	
	import UserService from '@/shared/services/UserService'

	export default 
	{

		data() { 
			return {
				user: {
					email: this.$route.params.email,
					token: this.$route.params.token,
					password: null,
					password_confirm: null
				}
			}
		},

	  methods: {

			async changePassword()
			{
				const resp = await UserService.changePasswordAuth(this.user)
				
				if(this.user.password == this.user.password_confirm)
				{
					if(resp.data == 'OK')
					{
						SwalAlert('', 'Contraseña restablecida exitosamente', 'success')
						this.$router.push('/autenticacion')
					}
					else
					{
						SwalAlert('', 'Ha ocurrido un error, por favor intenta de nuevo', 'error')
					}
				}
				else
				{
					SwalAlert('', 'Las contraseñas no coinciden', 'error')
				}
				
			}

		}
	}

</script>